module.exports = __webpack_public_path__ + "static/dhaval_sarvaiya-dc99d6ce2a351a4c95d1009406dd4441.png";